import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid, Paper } from '@mui/material';
import ListadoActividadesAcademicas from './components/ListadoActividadesAcademicas';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allActividadesAcademicasAction,
  setActivoActividadesAcademicasAction,
} from './ActividadesAcademicasAction';
import FormActividadesAcademicas from './components/FormActividadesAcademicas';

const ActividadesAcademicasView = () => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const actividadesAcademicasStore = Redux.useSelector(
    (state) => state.actividadesAcademicas,
  );

  const [isDelete, setIsDelete] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        {actividadesAcademicasStore.all.length > 0 && (
          <BotonComponent
            click={async () => {
              await setActivoActividadesAcademicasAction(dispatch, null);
              await allActividadesAcademicasAction(
                dispatch,
                actividadesAcademicasStore.params,
              );
            }}
            disabled={actividadesAcademicasStore.loadingAll}
            white
            text={
              actividadesAcademicasStore.loadingAll
                ? 'Actualizando...'
                : 'Actualizar'
            }
          />
        )}
      </Grid>
      {loginStore.isTeacher && (
        <Grid item md={3}>
          <Paper elevation={5} sx={{ pb: 1 }}>
            <FormActividadesAcademicas isDelete={isDelete} />
          </Paper>
        </Grid>
      )}
      <Grid item md={loginStore.isTeacher ? 9 : 12}>
        <ListadoActividadesAcademicas
          isDelete={isDelete}
          setIsDelete={(v) => setIsDelete(v)}
        />
      </Grid>
    </Grid>
  );
};

export default ActividadesAcademicasView;
